import { Lock, LockOpen } from "@mui/icons-material";
import { Chip } from "@mui/material";

interface AccessibilityChipProps {
  isPublic: boolean;
}

export const AccessibilityChip = ({ isPublic }: AccessibilityChipProps) => {
  return (
    <Chip
      size="small"
      icon={isPublic ? <LockOpen fontSize="small" /> : <Lock fontSize="small" />}
      label={isPublic ? "Open" : "Private"}
      color={isPublic ? "success" : "error"}
    />
  );
};
